import React from 'react';
import backgroundImage from '../assets/hero-background.jpg';
import logo from '../assets/logo.svg';

const Home = () => {
  return (
    <section id="home" className="hero" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="hero-content">
        <img src={logo} alt="Fire House Spirits Logo" className="hero-logo" />
        <h2>Crafted with intent.</h2>
        <h2>Experience spirits redefined.</h2>
        <a href="#collection" className="hero-btn">Discover Our Collection</a>
      </div>
    </section>
  );
};

export default Home;
